
import {debounceTime} from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ConsumerService } from '../../services/consumer.service';
import { UserService } from '../../services/user.service';
import { SiteService } from '../../services/site.service';
import { UntypedFormGroup, UntypedFormBuilder, FormControl } from '@angular/forms';
import { ClaimsService } from '../../services/claims.service';

@Component({
    selector: 'app-consumer-search-list',
    templateUrl: './consumer-search-list.component.html',
    styleUrls: ['./consumer-search-list.component.scss']
})
export class ConsumerSearchListComponent implements OnInit, OnDestroy {

    initialSearchPerformed: boolean = false;
    isSearching: boolean = false;
    results: any[] = [];
    filterList: any[] = [];
    searchTerm: string;
    page: number = 1;
    pageSize: number = 10;
    totalPages: number = 1;
    orderColumn: string;
    orderDirection: string;
    filter: any[] = [];
    allFilterIsActive = false;
    totalActive: number = 0;
    subscriptions: Subscription[] = [];
    clientId: number;
    sites: any[] = [];
    selectedSiteId: number = 0;
    form: UntypedFormGroup;

    @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
    @ViewChild('searchOrderInput') searchOrderInput: ElementRef;
    @ViewChild('siteId', { static: true }) siteId: ElementRef;

    private searchUpdate: Subject<string> = new Subject<string>();
    searchSubscription: Subscription = new Subscription();

    constructor(
        private consumerService: ConsumerService,
        private claimService: ClaimsService,
        private siteService: SiteService,
        private route: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder) { }

    ngOnInit() {
        this.initialSearchPerformed = false;
        this.subscriptions.push(this.route
            .parent!
            .params
            .subscribe(params => {
                this.clientId = +params['clientId'];
            }));

     

        this.form = this.fb.group({
            search: [null, null]
        });

        if (this.initialSearchPerformed) {
            this.subscriptions.push(this.form.controls['search'].valueChanges.subscribe(res => {
                this.searchUpdated(res);
            })
            );
        }

        this.subscriptions.push(this.route
            .parent!
            .params
            .subscribe(params => {
                this.clientId = +params['clientId'] || 1;
                this.page = +params['page'] || 1;
            }));

        let siteId: number = 0;
        if (this.route.snapshot.queryParams['siteId']) {
            this.siteId.nativeElement.value =
                parseFloat(this.route.snapshot.queryParams['siteId']);
        } else {
            this.updateSite();
        }

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(params => {
                if (!this.initialSearchPerformed) {
                    this.searchTerm = params['searchTerm'] || '';
                    this.orderColumn = params['orderColumn'] || 'site';
                    this.orderDirection = params['orderDirection'] || 'asc';

                    (params['filter'] && params['filter'].length > 0) ? this.filter = params['filter'] : this.filter[0] = 'active';
                    this.searchInput.nativeElement.value = this.searchTerm;
                    this.initialSearchPerformed = true;
                    this.selectedSiteId = parseFloat(params['siteId']) || 0;

                    // transform filter into array if it only has one value
                    if (this.filter && this.filter.constructor !== Array) {
                        let temp = this.filter;
                        this.filter = [];
                        this.filter[0] = temp;
                    }

                    this.search(this.selectedSiteId);
                }
            }));

        this.filterList.push(
            {
                key: "all",
                label: "All",
                amount: 0,
                isClicked: false,
                isDisabled: false
            },
            {
                key: "hasissue",
                label: "Issue",
                amount: 0,
                isClicked: this.filter.some(x => x == "hasissue"),
                isDisabled: false
            },
            {
                key: "vulnerable",
                label: "Vulnerable",
                amount: 0,
                isClicked: this.filter.some(x => x == "vulnerable"),
                isDisabled: false
            },
            {
                key: "active",
                label: "Current",
                amount: 0,
                isClicked: this.filter.some(x => x == "active"),
                isDisabled: false
            },
            {
                key: "payg",
                label: "PAYG",
                amount: 0,
                isClicked: this.filter.some(x => x == "payg"),
                isDisabled: (!this.claimService.hasPaygFeature() && !this.claimService.isSuperUser())
            },
            {
                key: "billing",
                label: "Billing",
                amount: 0,
                isClicked: this.filter.some(x => x == "billing"),
                isDisabled: (!this.claimService.hasBillingFeature() && !this.claimService.isSuperUser())
            }

        )

        const eventStream = this.searchUpdate.asObservable().pipe(
            debounceTime(300)).pipe(
            distinctUntilChanged());

        if (this.initialSearchPerformed) {
            this.subscriptions.push(eventStream.subscribe(input => this.search(this.selectedSiteId)));
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    updateSite() {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        if (this.selectedSiteId || this.selectedSiteId === 0) queryParams.siteId = +this.selectedSiteId;
        this.router.navigate(['/portal/' + this.clientId.toString() + '/consumers'], { queryParams: queryParams, replaceUrl: true });
    }

    pageSelected(page: number) {
        this.page = page;
        this.search();
    }

    filterUpdated(index: number = 0) {
        this.page = 1;
        this.allFilterIsActive = false;

        if (index == 5 && !this.filterList[5].isClicked) {
            this.filterList[4].isClicked = false;
            let index = this.filter.findIndex(x => x === "payg");
            if (index > -1) { this.filter.splice(index, 1); }
            this.filter
        }

        if (index == 4 && !this.filterList[4].isClicked) {
            this.filterList[5].isClicked = false;
            let index = this.filter.findIndex(x => x === "billing");
            if (index > -1) { this.filter.splice(index, 1); }
        }

        if (index == 0) {
            this.filter = [];
            for (var i = 0; i < this.filterList.length - 1; i++) {
                this.filterList[i + 1].isClicked = false;
            }
        } else {
            if (index != 0 && this.filterList[0].isClicked) { this.filter.splice(0, 1); }
            this.filterList[0].isClicked = false;

            if (!this.filterList[index].isClicked) {
                this.filter.push(this.filterList[index].key);
            } else {
                for (let j = 0; j < this.filter.length; j++) {
                    if (this.filterList[index].key == this.filter[j]) {
                        this.filter.splice(j, 1);
                    }
                }

            }

        }

        this.filterList[index].isClicked = !this.filterList[index].isClicked;
        this.search();
    }

    searchUpdated(value: string) {
        this.page = 1;
        this.searchTerm = value;
        this.searchUpdate.next(value);
    }

    sortUpdated(value: string) {
        this.page = 1;
        var parts = value.split(':');
        this.orderColumn = parts[0];
        this.orderDirection = parts[1];
        this.search(this.selectedSiteId);
    }

    search(siteId?: number) {
        this.isSearching = true;
        this.searchSubscription.unsubscribe();

        this.siteService.all(this.clientId).then((result) => {
            this.sites = result;
        });

        this.searchSubscription = this.consumerService.search(this.searchTerm, this.page, this.filter, this.orderColumn, this.orderDirection, this.clientId, this.selectedSiteId).subscribe((res) => {
            let result = (res as any);
            this.results = result.consumerDetails;
            this.pageSize = result.pageSize;
            this.totalPages = result.totalPages;
            this.filterList[0].amount = result.allCount;
            this.filterList[1].amount = result.hasIssueCount;
            this.filterList[2].amount = result.vulnerableCount;
            this.filterList[3].amount = result.activeCount;
            this.filterList[4].amount = result.paygCount;
            this.filterList[5].amount = result.billingCount;
            this.isSearching = false;

            var queryParams = {};
            if (this.searchTerm && this.searchTerm.trim().length > 0) {
                queryParams['searchTerm'] = this.searchTerm;
            }
            if (this.orderColumn && this.orderColumn.trim().length > 0) {
                queryParams['orderColumn'] = this.orderColumn;
            }

            if (this.orderDirection && this.orderDirection.trim().length > 0) {
                queryParams['orderDirection'] = this.orderDirection;
            }

            if (this.filter.length > 0) {
                queryParams['filter'] = this.filter;
            }

            if (queryParams['siteId'] !== this.selectedSiteId) {
                queryParams['siteId'] = this.selectedSiteId;
            }

            this.router.navigate(['/portal', this.clientId, 'consumers', this.page], { queryParams: queryParams, replaceUrl: true });
        });
    }
}
